var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3C2.26603 3 1 6 1 6C1 6 2.26603 9 6 9C9.73397 9 11 6 11 6C11 6 9.73397 3 6 3ZM6 8.3393C4.6891 8.3393 3.62821 7.29294 3.62821 6C3.62821 4.70706 4.6891 3.6607 6 3.6607C7.3109 3.6607 8.3718 4.70706 8.3718 6C8.3718 7.29294 7.3109 8.3393 6 8.3393Z",
    fill: "#62646E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 7.32779C6.74342 7.32779 7.34612 6.73335 7.34612 6.00008C7.34612 5.2668 6.74342 4.67236 5.99996 4.67236C5.2565 4.67236 4.65381 5.2668 4.65381 6.00008C4.65381 6.73335 5.2565 7.32779 5.99996 7.32779Z",
    fill: "#62646E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsIcon);
export default __webpack_public_path__ + "static/media/views_icon.adda75929fcc0521524b3044c19d8ff7.svg";
export { ForwardRef as ReactComponent };